import { createAction, props } from '@ngrx/store';

export const OpenDrawer = createAction('[Alio: Drawer]: Open');

export const CloseDrawer = createAction('[Alio: Drawer]: Close');

export const ToggleDrawer = createAction('[Alio: Drawer]: Toggle');

export const SetDrawerWidth = createAction('[Alio: Drawer]: Set Width', props<{ width: number }>());
